import { requestApi } from './Api';

export const getCards = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/token/list',
    params
  });

export const deleteCard = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/card/remove',
    params
  });

export const updateCard = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/card/update',
    params
  });
